var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.63,
    height: 21.73,
    viewBox: "0 0 21.63 21.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "search-question"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3,10.7a9.8,9.8,0,1,1,9.8,9.8A9.82,9.82,0,0,1,1.3,10.7Zm1.5,0A8.17,8.17,0,0,0,11,18.9a8.32,8.32,0,0,0,8.3-8.2A8.34,8.34,0,0,0,11,2.4,8.2,8.2,0,0,0,2.8,10.7ZM20,22.4c-.5-.1-1.3-.4-1.8-1.8a2.52,2.52,0,0,1,.2-2.1,2.2,2.2,0,0,1,1.9-.9,2.41,2.41,0,0,1,2.2,1.1,2.17,2.17,0,0,1-.3,2.4,2.37,2.37,0,0,1-2,1.3A.14.14,0,0,1,20,22.4Zm.2-1.4c.2,0,.5-.2.8-.6a.85.85,0,0,0,.2-.9q-.15-.3-.9-.3a.91.91,0,0,0-.7.3.85.85,0,0,0,0,.7A1.36,1.36,0,0,0,20.2,21Z",
    transform: "translate(-1.2 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "?"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.26 14.52) rotate(-0.27)",
    fontSize: 13,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.2 -0.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchQuestion);
export default __webpack_public_path__ + "static/media/search-question.07e678a09dc7b1011c0c9c91752df82f.svg";
export { ForwardRef as ReactComponent };